import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  user: any;

  constructor(
    private router: Router,
    private _auth: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const vm = this;
    vm.user = vm._auth.userObj;
    if (vm.user) {
      if (route.data.name === 'admin') {
        if (vm.user.isAdmin) {
          return true;
        } else {
          vm.router.navigate(['/auth/drivers-list']);
          return false;
        }
      } else {
        return true;
      }
    } else {
      vm.router.navigate(['/no-auth/sign-in']);
      return false;
    }
  }
}
